import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for RouteStore, for use in the registry */ export const RouteStoreActionTypes = [
    ActionType.NavigateToView,
    ActionType.PushSubRoute,
    ActionType.ReplaceSubRoute,
    ActionType.OpenModalAction,
    ActionType.CloseModalAction
];
